export enum WasteClassificationCode {
  HW = 'HW',
  NONHW = 'NONHW'
}
